<template>
    <div>
        <v-list v-for="subitem in node" :key="'vList1_' + subitem.catalogoCod">
            <div>
                <div v-if="subitem.hasFilho">
                    <div class="subitem-suspenso-menu">
                        <v-list-group :key="'vListGroup1_' + subitem.catalogoCod" no-action>
                            <template v-slot:activator>
                                <v-list-tile :key="'vListTile1_' + subitem.catalogoCod">
                                    <v-list-tile-content :key="'vListTileContent1_' + subitem.catalogoCod">
                                        <v-list-tile-title :key="'vListTileTitle1_' + subitem.catalogoCod">{{
                                            subitem.catalogoNome }}</v-list-tile-title>
                                    </v-list-tile-content>
                                </v-list-tile>
                            </template>
                            <MenuCatalogo :node="subitem.subCatalogo" :key="'subItem' + subitem.catalogoCod" />
                        </v-list-group>
                    </div>

                </div>
                <div v-else>
                    <v-list-tile :key="'vListTile2_' + subitem.catalogoCod" @click="">
                        <div class="subitem-menu">
                            <v-list-tile-content :key="'vListTileContent2_' + subitem.catalogoCod">
                                <v-list-tile-title :id="subitem.codigoFabricante" style="cursor: pointer;"
                                    @click="addIdFabricante($event)" :key="'vListTileTitle2_' + subitem.catalogoCod">
                                    {{ subitem.catalogoNome }}
                                </v-list-tile-title>
                            </v-list-tile-content>
                        </div>
                    </v-list-tile>
                </div>
            </div>
        </v-list>
    </div>
</template>  

<script>
export default {
    name: 'MenuCatalogo',
    props: {
        node: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            idFabricanteList: [],
        };
    },
    methods: {
        addIdFabricante(event) {            
            const id = event.target.id;
            this.idFabricanteList.push(id); // Adicione o ID à lista existente
            console.log("this.idFabricanteList -> ", this.idFabricanteList);

            // Acesse o valor de filtroCatalogo usando o getter
            // idFabricanteList = this.$store.getters['anuncio/filtroCatalogo'];
            // console.log("idFabricanteList -> ", idFabricanteList);
            //this.$store.getters['anuncio/filtroCatalogo'];
            
            this.$store
                .dispatch("anuncio/filtrarCatalogos", { codFabricante: [id], codEmpresa: this.$route.params.id })
                .then(() => {
                    this.hideLoading();
                })
                .catch(() => {
                    this.hideLoading();
                });

            

        }
    }
}
</script>

<style>
.menu-catalogo {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    margin: 15px 15px;
    width: 98%;
    background-color: #fff;
    font-size: small;
}

.subitem-menu {
    display: flex;
    justify-content: flex-start;
    margin-left: 30px;
}

.subitem-suspenso-menu {
    display: flex;
    justify-content: flex-start;
    margin-left: 15px;
}

.pointer-cursor {
    cursor: pointer;
}
</style>